/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import AtomicDrawerHeader from '../../../atomic/DrawerHeader'
import styles from './DrawerHeader.module.css'

const DrawerHeader = ({ onClose }: { onClose: () => void }) => {
  const { copies } = useHeaderContext()
  const { clients } = copies || {}
  const { user } = clients?.generalheader || {}

  return (
    <AtomicDrawerHeader
      onClose={onClose}
      copy={user?.account}
      className={styles.drawerHeader}
    />
  )
}

export default DrawerHeader
